import React, { useState } from 'react';

function PaymentModal({ tributeId, onClose }) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [senderEmail, setSenderEmail] = useState('');
    const [promoCodeInput, setPromoCodeInput] = useState('');
    const [appliedPromoCode, setAppliedPromoCode] = useState('');
    const [promoCodeMessage, setPromoCodeMessage] = useState('');
    const [isPromoValidating, setIsPromoValidating] = useState(false);

    const handleValidatePromoCode = async () => {
        if (!promoCodeInput.trim()) {
            return;
        }

        setIsPromoValidating(true);
        setPromoCodeMessage('');

        try {
            const response = await fetch(`/api/promo-codes/${encodeURIComponent(promoCodeInput.trim())}/validate`);
            if (!response.ok) {
                throw new Error('Błąd podczas weryfikacji kodu.');
            }

            const isValid = await response.json();
            if (isValid) {
                setAppliedPromoCode(promoCodeInput.trim());
                setPromoCodeMessage('Kod rabatowy został pomyślnie dodany.');
            } else {
                setAppliedPromoCode('');
                setPromoCodeMessage('Podany kod rabatowy jest niepoprawny lub wygasł.');
            }
        } catch (e) {
            setAppliedPromoCode('');
            setPromoCodeMessage('Nie udało się zweryfikować kodu rabatowego.');
        } finally {
            setIsPromoValidating(false);
        }
    };

    const handlePayment = async () => {
        setError('');

        if (!isChecked) {
            setError('Musisz wyrazić zgodę na rozpoczęcie świadczenia Usługi.');
            return;
        }

        const trimmedEmail = senderEmail.trim();

        if (trimmedEmail !== '') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(trimmedEmail)) {
                setError('Podany adres e-mail jest nieprawidłowy.');
                return;
            }
        }

        setIsLoading(true);
        try {
            const payload = {
                tributeId: tributeId,
                ...(appliedPromoCode && { promoCode: appliedPromoCode }),
                ...(trimmedEmail && { senderEmail: trimmedEmail })
            };

            const response = await fetch('/api/tributes/pay', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                let errorMessage = `Płatność nie powiodła się! status: ${response.status}`;
                try {
                    const errorData = await response.json();
                    errorMessage = errorData.message || errorMessage;
                } catch (e) {
                }
                throw new Error(errorMessage);
            }

            const data = await response.json();

            if (data && data.redirectUrl) {
                window.location.href = data.redirectUrl;
            } else {
                throw new Error('Nie otrzymano linku do płatności.');
            }

        } catch (e) {
            console.error('Payment error:', e);
            setError(e.message || 'Płatność nie powiodła się. Spróbuj ponownie.');
            setIsLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(event) => event.stopPropagation()}>
                <button type="button" className="close-icon-button" onClick={onClose}>
                    &#x2715;
                </button>
                <h2>{'Zapal i pobierz znicz'}</h2>
                <p className="payment-modal-message">
                    {'Aby móc pobrać wirtualny znicz i swobodnie udostępniać go bliskim, wymagana jest jednorazowa opłata.'}
                </p>
                {error && <p style={{ color: 'red' }}>Błąd: {error}</p>}

                <button
                    onClick={handlePayment}
                    className="download-button payment-modal-link"
                    disabled={isLoading}
                    style={{ marginBottom: '0.25rem' }}
                >
                    {isLoading ? 'Przetwarzanie...' : 'Opłać i utrwal znicz - 4,99 zł'}
                </button>

                <div className="consent-checkbox-container" style={{ marginTop: '15px', marginBottom: '15px' }}>
                    <input
                        type="checkbox"
                        id="payment-consent"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                    />
                    <label htmlFor="payment-consent">
                        <b>Wyrażam zgodę</b> na rozpoczęcie świadczenia Usługi „Zapal Znicz” przed upływem 14 dni od zawarcia umowy. Zostałem poinformowany i przyjmuję do wiadomości, że po pełnym wykonaniu Usługi utracę prawo odstąpienia od umowy.
                    </label>
                </div>

                <div className="email-input-container" style={{ marginBottom: '15px' }}>
                    <div className="promo-code-row">
                        <input
                            type="email"
                            placeholder="Twój adres e-mail"
                            value={senderEmail}
                            onChange={(e) => setSenderEmail(e.target.value)}
                        />
                    </div>
                    <p style={{ fontSize: '11px', color: '#666', marginTop: '5px', textAlign: 'left' }}>
                        Adres e-mail jest potrzebny wyłącznie do realizacji płatności i nie jest przez nas przechowywany.
                    </p>
                </div>

                <div className="promo-code-container">
                    <div className="promo-code-row">
                        <input
                            type="text"
                            placeholder="Kod rabatowy"
                            value={promoCodeInput}
                            onChange={(e) => setPromoCodeInput(e.target.value)}
                            disabled={isPromoValidating || Boolean(appliedPromoCode)}
                        />
                        <button
                            type="button"
                            className="promo-code-button"
                            onClick={handleValidatePromoCode}
                            disabled={isPromoValidating || !promoCodeInput.trim() || Boolean(appliedPromoCode)}
                        >
                            {isPromoValidating ? 'Sprawdzanie...' : 'Dodaj'}
                        </button>
                    </div>
                    {promoCodeMessage && (
                        <p className={`promo-code-message ${appliedPromoCode ? 'success' : 'error'}`}>
                            {promoCodeMessage}
                        </p>
                    )}
                </div>

                <p className="payment-modal-note">
                    {'Po dokonaniu opłaty przekierujemy Cię do Twojego znicza, który będzie mógł płonąć na zawsze.'}
                </p>
            </div>
        </div>
    );
}

export default PaymentModal;
